import React, { useEffect, useState }  from "react";
import Paper from "../../common/Paper";
import TabPanel from "../../common/TabPanel";
import Tabs from "../../common/Tabs";
import styles from "./index.module.css";
import html2pdf from "html2pdf.js";
import { axiosInstance } from "../../../utils/axiosInstance";
import { useParams } from "react-router-dom"; 


const HealthPlanProvidersDetails = () => {
  const [singleHealthPlanProvider, setSingleHealthPlanProvider] = useState();
const { id } = useParams();

useEffect(() => {
  const fetchSingleHealthPlanProvider = async () => {
    try {
       const response = await axiosInstance.get(`/v1/admin/providers/${id}`);
      setSingleHealthPlanProvider(response?.data?.data);
    } catch (error) {
      console.error("Error fetching health plan provider details:", error);
      
    }
  };
  fetchSingleHealthPlanProvider();
}, [id]);


const handleDownload = () => {
      const element = document.getElementById("pdf-content");
      const opt = {
        margin: 1,
        filename: "my_page.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
  
      html2pdf().set(opt).from(element).save();
    };


  return (
    <Paper className="mb-5">
      <button className="pdf-download" onClick={handleDownload}>
        Download as PDF
      </button>
      <div id="pdf-content">
        <Tabs
          activeTab={"HealthPlanProviders Details"}
          tabData={["HealthPlanProviders Details", "", "", "", ""]}
          tabIndex={0}
          onTabChange={(index) => console.log(index)}
        />

        <div className={styles["tab-panel-body"]}>
          <TabPanel value={0} index={0}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th> Name</th>
                  <th>Location</th>
                  <th>Address</th>
                  <th>Health Plan ID</th>
                  <th>Health Plan Name</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{singleHealthPlanProvider?.id}</td>
                  <td>{singleHealthPlanProvider?.name} </td>
                  <td>{singleHealthPlanProvider?.location}</td>
                  <td>{singleHealthPlanProvider?.address}</td>
                  <td>
                    {singleHealthPlanProvider?.health_plan_id || "N/A"}
                  </td>
                  <td>
                    {singleHealthPlanProvider?.health_plan_id === 1
                      ? "EXCLUSIVE"
                      : singleHealthPlanProvider?.health_plan_id === 2
                      ? "PREMIUM"
                      : singleHealthPlanProvider?.health_plan_id === 3
                      ? "SHIELD"
                      : singleHealthPlanProvider?.health_plan_id === 4
                      ? "GUARD"
                      : singleHealthPlanProvider?.health_plan_id === 5
                      ? "BASIC" : "UNKNOWN"}
                  </td>
                </tr>
              </tbody>
            </table>
          </TabPanel>
        </div>
      </div>
    </Paper>
  );
};

export default HealthPlanProvidersDetails;
